import { render, staticRenderFns } from "./AS_TechSpecification.vue?vue&type=template&id=ffe7c396&scoped=true&"
import script from "./AS_TechSpecification.vue?vue&type=script&lang=js&"
export * from "./AS_TechSpecification.vue?vue&type=script&lang=js&"
import style0 from "./AS_TechSpecification.vue?vue&type=style&index=0&id=ffe7c396&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe7c396",
  null
  
)

export default component.exports